import { jsx, jsxs, Fragment } from "react/jsx-runtime";
import { getComposableTextByDevFieldKey } from "../../../../../utils/contentstack/lib.js";
import { capitalizeFirstLetter } from "../../../../../utils/string.js";
import { Skeleton, Text } from "@nxt-costco-com/forge-components";
import { getMembershipCategory, getMembershipCard, findBodyTextItemByDevFieldKey } from "../utils.js";
import { MEMBERSHIP_CARD_ALT_TEXT_PREFIX, MEMBERSHIP_CARD_IMAGE_TEST_ID } from "../../constants.js";
import { CostcoBox } from "../../../../Util/CostcoBox.js";
import GenericImageHandler from "../../../../Util/GenericImageHandler.js";
import { UserInfoContainerSx, BottomInfoContainerSx, CardImageSx, BottomTextContainerSx } from "./styles.js";
const UserInfo = ({
  moduleSettings,
  membershipTypes,
  locale,
  memberStatus,
  isLoading
}) => {
  var _a;
  if (isLoading) {
    return /* @__PURE__ */ jsx(CostcoBox, { sx: UserInfoContainerSx, children: /* @__PURE__ */ jsx(Skeleton, { variant: "textHeader", width: 205 }) });
  }
  const { composable_window } = moduleSettings;
  const membershipInfo = membershipTypes.custom.membershipInfo;
  const statusMembershipType = memberStatus == null ? void 0 : memberStatus.membershipType;
  const memberFirstName = (memberStatus == null ? void 0 : memberStatus.memberFirstName) ?? "";
  const memberSinceYear = (_a = memberStatus == null ? void 0 : memberStatus.memberSince) == null ? void 0 : _a.substring(0, 4);
  const membershipTier = memberStatus == null ? void 0 : memberStatus.membershipTier;
  const verifiedMembership = memberStatus == null ? void 0 : memberStatus.verifiedMembership;
  const membershipCategory = getMembershipCategory({
    locale,
    membershipInfo,
    membershipTier,
    statusMembershipType
  });
  const membershipCardUrl = statusMembershipType && membershipTier && getMembershipCard(
    statusMembershipType,
    membershipTier,
    composable_window
  );
  const hasAllMemberData = verifiedMembership && membershipInfo && memberFirstName && statusMembershipType && memberSinceYear && membershipTier && membershipCardUrl;
  const templateVariables = {
    firstName: capitalizeFirstLetter(memberFirstName.toLowerCase()),
    membershipTier,
    membershipType: statusMembershipType,
    year: memberSinceYear
  };
  const generalGreeting = getComposableTextByDevFieldKey({
    devFieldKey: "generalGreeting",
    composableWindow: composable_window,
    templateVariables
  });
  const memberGreeting = getComposableTextByDevFieldKey({
    devFieldKey: "memberGreeting",
    composableWindow: composable_window,
    templateVariables
  });
  const memberText = getComposableTextByDevFieldKey({
    devFieldKey: "memberText",
    composableWindow: composable_window,
    templateVariables
  });
  const memberSince = getComposableTextByDevFieldKey({
    devFieldKey: "memberSince",
    composableWindow: composable_window,
    templateVariables
  });
  const membershipCardAltTextPrefix = findBodyTextItemByDevFieldKey(
    moduleSettings.composable_window,
    MEMBERSHIP_CARD_ALT_TEXT_PREFIX
  );
  return /* @__PURE__ */ jsxs(
    CostcoBox,
    {
      "data-testid": "accountdrawer-greeting",
      "data-private": true,
      sx: UserInfoContainerSx,
      children: [
        !hasAllMemberData && /* @__PURE__ */ jsx(
          Text,
          {
            bold: true,
            component: "h2",
            uniqueId: "accountdrawer-generalgreeting",
            variant: "t4",
            children: generalGreeting
          }
        ),
        hasAllMemberData && /* @__PURE__ */ jsxs(Fragment, { children: [
          /* @__PURE__ */ jsx(
            Text,
            {
              bold: true,
              component: "h2",
              uniqueId: "accountdrawer-membergreeting",
              variant: "t4",
              children: memberGreeting
            }
          ),
          /* @__PURE__ */ jsxs(CostcoBox, { sx: BottomInfoContainerSx, children: [
            /* @__PURE__ */ jsx(
              GenericImageHandler,
              {
                alt: `${membershipCardAltTextPrefix} ${membershipCategory}`,
                "data-testid": MEMBERSHIP_CARD_IMAGE_TEST_ID,
                loading: "lazy",
                src: membershipCardUrl,
                sx: CardImageSx
              }
            ),
            /* @__PURE__ */ jsxs(CostcoBox, { sx: BottomTextContainerSx, children: [
              /* @__PURE__ */ jsx(
                Text,
                {
                  bold: true,
                  uniqueId: "accountdrawer-membergreeting-membershipcategory",
                  variant: "t6",
                  children: memberText
                }
              ),
              /* @__PURE__ */ jsx(
                Text,
                {
                  uniqueId: "accountdrawer-membergreeting-membersince",
                  variant: "body",
                  children: memberSince
                }
              )
            ] })
          ] })
        ] })
      ]
    }
  );
};
export {
  UserInfo
};
